module.exports = __webpack_public_path__ + "static/img/lg-archive-img-02-02@w.e635826.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-archive/lg-archive-img-02-02@w.jpg
// module id = UH8X
// module chunks = 0